import {
  AsyncOption,
  IAsyncDropdownModel,
  IDropdownModel,
} from "common/models/IDropdownModel";
import { ApiBase } from "config";
import api from "utils/api";

const dropdownUrl = `${ApiBase}/api/dropdown`;

function getMemberCode(value: string | null, label: string | null) {
  return api.post<IAsyncDropdownModel[]>(`${dropdownUrl}/getMemberCode`, {
    value: value,
    label: label,
  });
}

function getMaterialAutoComplete(value: string | null, label: string | null) {
  return api.post<IAsyncDropdownModel[]>(`${dropdownUrl}/getMaterialID`, {
    value: value,
    label: label,
  });
}

function getRackAutoComplete(value: string | null, label: string | null) {
  return api.post<IAsyncDropdownModel[]>(`${dropdownUrl}/getRackAutoComplete`, {
    value: value,
    label: label,
  });
}

function getAccessionNo(value: string | null, label: string | null) {
  return api.post<IAsyncDropdownModel[]>(`${dropdownUrl}/getAccessionNo`, {
    value: value,
    label: label,
  });
}
function getAccessionNoIdName(id: string | null, name: string | null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAccessionNoIdName`, {
    id: id,
    name: name,
  });
}
function getMemberCodeIdName(value: string | null, label: string | null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getMemberCodeIdName`, {
    value: value,
    label: label,
  });
}
function getAuthorValuesByNameAndId(
  inputValue: string | null,
  id: number | null,
) {
  return api.post<IDropdownModel[]>(`${dropdownUrl}/getAuthorByNameAndId`, {
    name: inputValue,
    id: id,
  });
}

function getPublicationAutoComplete(
  inputValue: string | null,
  id: number | null,
) {
  return api.post<IDropdownModel[]>(
    `${dropdownUrl}/getPublicationByNameAndID`,
    {
      name: inputValue,
      id: id,
    },
  );
}

function getClassificationAutoComplete(
  inputValue: string | null,
  id: number | null,
) {
  return api.post<IDropdownModel[]>(
    `${dropdownUrl}/getClassificationByNameAndID`,
    {
      name: inputValue,
      id: id,
    },
  );
}

function getSupplierAutoComplete(value: string | null, label: string | null) {
  return api.post<IDropdownModel[]>(`${dropdownUrl}/getSupplierByNameAndID`, {
    value: value,
    label: label,
  });
}

function getRoleAutoComplete(inputValue: string | null, id: string | null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteRoles`, {
    name: inputValue,
    id: id,
  });
}

function getLibraryAutoComplete(inputValue: string | null, id: string | null) {
  return api.post<AsyncOption[]>(`${dropdownUrl}/getAutoCompleteLibraries`, {
    name: inputValue,
    id: id,
  });
}

function getILLMaterialAutoComplete(
  value: string | null,
  label: string | null,
) {
  return api.post<IAsyncDropdownModel[]>(
    `${dropdownUrl}/getILLMaterialAutoComplete`,
    {
      value: value,
      label: label,
    },
  );
}

function getILLAccessionsForApproval(materialId: string | number, libraryId?: string | number) {
  return api.get<IAsyncDropdownModel[]>(
    `${dropdownUrl}/getILLAccessionsForApproval/${materialId}${libraryId ? `?libraryId=${libraryId}` : ""}`,
  );
}

export default {
  getMemberCode,
  getMaterialAutoComplete,
  getRackAutoComplete,
  getAccessionNo,
  getAccessionNoIdName,
  getMemberCodeIdName,
  getAuthorValuesByNameAndId,
  getPublicationAutoComplete,
  getClassificationAutoComplete,
  getSupplierAutoComplete,
  getRoleAutoComplete,
  getLibraryAutoComplete,
  getILLMaterialAutoComplete,
  getILLAccessionsForApproval
};
